const nomItemLocalStorage = 'webxom-token';

export const guardarToken = token => {
    localStorage.setItem(nomItemLocalStorage, token);
};

export const eliminarToken = () => {
    localStorage.removeItem(nomItemLocalStorage);
};

export const obtenirToken = () => localStorage.getItem(nomItemLocalStorage);



// WEBPACK FOOTER //
// ./src/commons/gestioWebToken.js